exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "auditresultsummary h6{text-align:right;margin-right:10px}auditresultsummary h6:last-of-type{margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./client/app/common/reports/auditresultsummary/auditresultsummary.styl
// module id = 61
// module chunks = 1